import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CartridgeBookingService } from '@markant-platform/cartridge/feature-booking';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartridgeMembersOverviewOrganizationIdResolver {
  private readonly cartridgeBookingService: CartridgeBookingService = inject(CartridgeBookingService);

  resolve(route: ActivatedRouteSnapshot): Observable<string> {
    const bookingId = route.paramMap.get('bookingId') as string;

    return this.cartridgeBookingService.getBookingById(bookingId).pipe(map(({ organizationId }) => organizationId));
  }
}
